"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class GetReviewStatisticsResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.Docs)({
        example: 47012,
        description: 'The total amount of reviews existing at klantenvertellen',
    }),
    tslib_1.__metadata("design:type", Number)
], GetReviewStatisticsResponse.prototype, "totalReviews", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.Docs)({
        example: 81,
        description: 'The percentage of all reviews from the last 12 months that would recommend the brand',
    }),
    tslib_1.__metadata("design:type", Number)
], GetReviewStatisticsResponse.prototype, "recommendPercentage", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.Docs)({
        example: 8.1,
        description: 'The average rating of all reviews from the last 12 months combined',
    }),
    tslib_1.__metadata("design:type", Number)
], GetReviewStatisticsResponse.prototype, "averageRating", void 0);
exports.default = GetReviewStatisticsResponse;
